import { useCallback, useMemo, useRef, useState } from "react";

export const useUISlice = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [leftSidebarCollapse, setLeftSidebarCollapse] = useState(false);
  const [rightSidebarCollapse, setRightSidebarCollapse] = useState(true);
  const [refresh, setRefresh] = useState(true);
  const [columnVisibilities, setColumnVisibilities] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [isSaveVisible, _setIsSaveVisible] = useState(false);
  const [isSaveSuccess, setIsSaveSuccess] = useState(false);
  const [isSaveError, setIsSaveError] = useState(false);

  // Debug wrapper — logs every call that changes isSaveVisible so we can track which component resets it
  const setIsSaveVisible = useCallback((val) => {
    const caller = new Error().stack?.split('\n')?.[2]?.trim() ?? 'unknown';
    console.log(`[useUISlice] setIsSaveVisible(${val}) called from:`, caller);
    _setIsSaveVisible(val);
  }, []);
  const [alerts, setAlerts] = useState([]);
  const currentAlert = useMemo(() => (alerts.length > 0 ? alerts[0] : null), [alerts]);
  const alertSeq = useRef(0);
  const enqueueAlert = useCallback((alert) => {
    const id = ++alertSeq.current;

    setAlerts((prev) => [
      ...prev,
      {
        id,
        message: alert?.message ?? "",
        severity: alert?.severity ?? "success",
        duration: alert?.duration ?? 2000,
        anchorOrigin: alert?.anchorOrigin ?? { vertical: "bottom", horizontal: "right" },
      },
    ]);

    return id;
  }, []);
  const dequeueAlert = useCallback(() => {
    setAlerts((prev) => (prev.length > 0 ? prev.slice(1) : prev));
  }, []);
  const clearAlerts = useCallback(() => setAlerts([]), []);

  return useMemo(
    () => ({
      selectedLanguage,
      setSelectedLanguage,
      leftSidebarCollapse,
      setLeftSidebarCollapse,
      rightSidebarCollapse,
      setRightSidebarCollapse,
      refresh,
      setRefresh,
      columnVisibilities,
      setColumnVisibilities,
      isLoading,
      setIsLoading,
      isSaveClicked,
      setIsSaveClicked,
      isSaveVisible,
      setIsSaveVisible,
      isSaveSuccess,
      setIsSaveSuccess,
      isSaveError,
      setIsSaveError,
      alerts,
      currentAlert,
      enqueueAlert,
      dequeueAlert,
      clearAlerts,
    }),
    [
      selectedLanguage,
      leftSidebarCollapse,
      rightSidebarCollapse,
      refresh,
      columnVisibilities,
      isLoading,
      isSaveClicked,
      isSaveVisible,
      isSaveSuccess,
      isSaveError,
      alerts,
      currentAlert,
      enqueueAlert,
      dequeueAlert,
      clearAlerts,
    ]
  );
};
